<template>
    <div class="form-group">
        <label :for="identifier" v-if="label">{{ label }} {{ requiredAsterisk }}</label>
        <span
            v-if="infoText"
            class="info-button"
            data-trigger="hover focus"
            data-container="body"
            v-popover
            data-placement="top"
            data-html="true"
            data-original-title=""
            title=""
            :data-content="infoText"
            tabindex="0"
        ></span>
        <input
            :type="'type' in $attrs ? $attrs.type : 'text'"
            class="form-control"
            :class="{'is-invalid': valid === false}"
            :id="identifier"
            :name="filteredName"
            :value="fieldValue"
            @input="updateValue($event.target.value)"
            :aria-invalid="!valid"
            :aria-describedby="identifierError"
            v-bind="attributes"
        >
        <small class="form-text text-muted" v-if="helpText">{{ helpText }}</small>
        <div :id="identifierError" class="invalid-tooltip" v-html="errorMessages" />
    </div>
</template>
<script>
import FormField from "@/mixins/FormField";

export default {
    name: 'TextInput',
    mixins: [FormField],
    inheritAttrs: false,
    props: {
        helpText: {
            type: String,
            required: false,
        },
        infoText: {
            type: String,
            required: false,
            default: '' // Optionaler Standardwert
        },
    },
}
</script>
